import { logger } from '@/shared/utils';
import { mirrorflyRegister } from '@/features/auth/mirrorfly/authUtils';
import { toast } from 'react-toastify';
import storage from '@/shared/utils/storage';
import { store } from '@/app/store';
import { setAuthStep } from '@/app/store/authSlice';

export const handleSSORegistration = async ({ id = '', email = '' } = {}) => {
   try {
      const res = await mirrorflyRegister({
         userIdentifier: id,
         email,
      });
      if (res?.statusCode === 200) {
         storage.setItem('login_user_email', email);
         store.dispatch(setAuthStep('updateProfile'));
         storage.setItem('auth_flow', 'updateProfile');
      }
      return res;
   } catch (error) {
      logger.error('SSO Registration error:', error);
      toast.error(error.message || 'SSO Registration failed');
      throw error;
   }
};
